exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog_wrapper .el-dialog__headerbtn .el-dialog__close {\n  font-size: 24px;\n}\n.dialog_wrapper .el-dialog {\n  border-radius: 6px;\n}\n.dialog_wrapper .el-button + .el-button {\n  margin-left: 20px;\n}", ""]);

// exports
